import * as React from 'react';

const SvgArrowRighyWhite = (props) => (
  <svg
    width={25}
    height={24}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.4 5.4a.75.75 0 0 1 1.06 0l6.07 6.07a.75.75 0 0 1 0 1.06l-6.07 6.07a.75.75 0 0 1-1.06-1.06L19.94 12 14.4 6.46a.75.75 0 0 1 0-1.06Z'
      fill='#fff'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.25 12a.75.75 0 0 1 .75-.75h16.83a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75Z'
      fill='#fff'
    />
  </svg>
);

export default SvgArrowRighyWhite;
